// extracted by mini-css-extract-plugin
module.exports = {"main":"NavbarMenuWithoutTabs_main__3TiPE","titleSpan":"NavbarMenuWithoutTabs_titleSpan__34ID6","dataDiv":"NavbarMenuWithoutTabs_dataDiv__3f3hW"};